import { CommonModule } from '@angular/common';
import {
  Component,
  HostListener,
  OnDestroy,
  OnInit,
} from '@angular/core';
import { RouterLink } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { UserModel } from '../../../../models/user.model';
import { InitialsPipe } from '../../../../pipes/initials.pipe';
import * as userActions from '../../../../state/actions/user.actions';
import { AppState } from '../../../../state/appstate';

@Component({
  selector: 'app-user-dropdown',
  standalone: true,
  imports: [CommonModule, RouterLink, InitialsPipe],
  templateUrl: './user-dropdown.component.html',
})
export class UserDropdownComponent implements OnInit, OnDestroy {
  dropdownPopoverShow = false;

  userSub: Subscription | undefined;
  user: UserModel | null = null;

  constructor(private store: Store<AppState>) {}

  ngOnDestroy(): void {
    this.userSub?.unsubscribe();
  }

  ngOnInit(): void {
    this.userSub = this.store
      .select((state) => state.user.user)
      .subscribe((user) => {
        this.user = user;
      });
  }

  @HostListener('document:click')
  onDocumentClick() {
    this.dropdownPopoverShow = false;
  }

  toggleDropdown(event: any) {
    event.preventDefault();
    if (this.dropdownPopoverShow) {
      this.dropdownPopoverShow = false;
    } else {
      this.dropdownPopoverShow = true;
    }
  }

  signOut() {
    this.store.dispatch(userActions.logout());
  }
}
